import {
  ApiCppiStrategy,
  useGetByTenantAccountAndAccountSourceAccountIdentifierQuery
} from 'api/rtk-api'
import { Card, LabelValueRow, Tabs } from 'components/core-v2'
import { format } from 'date-fns'
import { useParams } from 'react-router-dom'

import { TENANT } from '@/const'
import { Currency, formatCurrencyFull } from '@/utilities/currency'

import { Loading } from './loading'

export const DetailsTermsTab = () => {
  const { source, tradeId } = useParams()
  const { data, isLoading } = useGetByTenantAccountAndAccountSourceAccountIdentifierQuery({
    tenant: TENANT,
    accountIdentifier: tradeId,
    accountSource: source
  })
  if (isLoading) return <Loading />

  const { accountName, dateOpened, strategy } = data.account
  const latestSnapshot = data.accountSnapShots.at(-1)
  const isCPPI = strategy.type === 'CPPI'

  return (
    <Tabs.Panel value="terms">
      <Card.Wrapper>
        <LabelValueRow label="Trade name" value={accountName} />
        <LabelValueRow
          label="Net contributions"
          value={formatCurrencyFull(
            latestSnapshot.netContributions,
            latestSnapshot.notionalCurrency as Currency
          )}
        />
        <LabelValueRow
          label="Start date"
          showBottomBorder={!isCPPI}
          value={format(new Date(dateOpened), 'd LLLL yyyy')}
        />
        {isCPPI && (
          <LabelValueRow
            showBottomBorder
            label="Maturity date"
            value={(strategy as ApiCppiStrategy).maturityDate}
          />
        )}
      </Card.Wrapper>
    </Tabs.Panel>
  )
}
